"use strict";

var convertCamelcaseToHuman = function convertCamelcaseToHuman(value) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
  return value.substring(0, 1).toUpperCase() + value.substring(1).replace(/([^\s0-9])([A-Z0-9])/g, function ($0, $1, $2) {
    return $1 + delimiter + $2;
  });
};

module.exports = convertCamelcaseToHuman;